<template>
  <div>
    <v-flex xs12 sm12 md12 v-if="items && items.length>0">
      <v-list class="xs12 mt-0 pt-0" two-line>

        <template v-for="(e, index) in items">
          <v-list-tile :key="e.id">
            <v-list-tile-avatar :key="`icon_${e.id}`" v-if="icons">
              <v-icon v-if="e.category=='monitor'">mdi-monitor</v-icon>
              <v-icon v-if="e.category=='projector'">mdi-projector</v-icon>
              <v-icon v-if="e.category=='motor'">mdi-engine</v-icon>
              <v-icon v-if="e.category=='bulb'">mdi-lightbulb</v-icon>
              <v-icon v-if="e.category=='switch'">mdi-nintendo-switch</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content :key="`title_${e.id}`">
              <v-list-tile-title>{{e.brand}} {{e.title}} {{e.type}}</v-list-tile-title>
              <v-list-tile-sub-title>{{e.category}} {{e.brand}} {{category(e)}}</v-list-tile-sub-title>
            </v-list-tile-content>
            <!-- <v-list-tile-action>
              <v-btn @click="edit(e)" icon ><v-icon small>edit</v-icon></v-btn>
            </v-list-tile-action>
            <v-list-tile-action v-if="c_user.delete_rights">
              <v-btn @click="dialog=true" icon ><v-icon small>delete</v-icon></v-btn>
            </v-list-tile-action> -->
          </v-list-tile>
          <v-divider v-if="index+1 < items.length" :key="`div${e.id}`"></v-divider>
        </template>

      </v-list>
    </v-flex>
    <v-flex class="mr-0 mt-0 mb-0 xs12" v-show="!showUpload">
      <v-btn small class="right elevation-0" @click="showUploadForm()"><v-icon class="mr-2">add</v-icon> Add new {{title}}</v-btn>
    </v-flex>

    <v-dialog v-model="dialog" max-width="400px">
      <v-card>
        <v-card-title class="headline">Are you sure you want to delete this device?</v-card-title>
        <v-card-text> This {{title}} will be deleted. </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" @click="dialog=false">No</v-btn>
          <v-btn color="green darken-1" @click="deleteItem(deletingItem)"> Yes</v-btn>
        </v-card-actions>
      </v-card>          
    </v-dialog>    
  </div>
</template>

<script>
  export default {
    props: ['items','icons','title','showUpload'],
    data: () => ({
      items2: '',
      editedItem: '',
      deletingItem: '',
      showUploadLocal: this.showUpload,
      dialog: false
    }),
    methods: {
      category (e) {
        var a = this.$store.state.categories.find(f=> f==e.type)
        if (a) {
          return a.name
        } else {
          return ''
        }
        return 
      },
      showUploadForm () {
        this.showUploadLocal = !this.showUploadLocal
        this.$emit('showUpload', !this.showUploadLocal)
      },
      deleteDevice (d) {
        // var index = exhibition_artworks.indexOf(e);
        // console.log('index = ' + index)
        // exhibition_artworks.splice(index,1)
        this.$store.dispatch('deleteDevice',d)
        this.dialog = false
      },      
      edit (e) {
        this.editedItem = e
        this.showUpload = true
      },
      deleteItem (d) {
        // var index = exhibition_artworks.indexOf(e);
        // console.log('index = ' + index)
        // exhibition_artworks.splice(index,1)
        this.$store.dispatch('deleteDevice',d)
        this.dialog = false
      },      
      saveIteml () {
        this.electrical.artwork_id = this.artwork.id
        this.electrical.done = false
        this.electrical.id = this.findMinMax(this.all_electricals)+1
        this.$store.commit('ADD_ELECTRICAL', this.electrical)
        // this.all_electricals.push(this.electrical)
        this.showUpload=!this.showUpload
        this.electrical = {
          description: '',
          title: '',
          deadline: '',
          done: false
        }
        // var aelectrical = Object.keys(this.electrical).forEach(k => this.electrical[k]='')
        // console.log(aelectrical)
      },
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/artworks/ElementsTable.vue